import React from 'react';
import styled from 'styled-components';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    getStatAction, getBrandProductInfoAction, setSearchFilerIndexAction, setSearchFilterDataAction, reSetStatErrorAction,
    reSetBrandProductErrorAction, getBrandProductDefaultAction, reSetBrandProductDefaultErrorAction, setSaveTextAction
} from '../../modules/search/searchModule';
import {isMobileOnly} from 'react-device-detect';

const SearchBrandTabBlock = styled.div`
    ${isMobileOnly?`
    margin-left: -4vw;
    width: 100vw;
    `:`
    
    `};
`;

const SearchBrandTabFilterTopBlock = styled.div`
    ${isMobileOnly?`
    padding-left: 4vw;
    `:`
    
    `};
`;

const SearchBrandTabFilterTopUlBlock = styled.ul`
    
`;

const SearchBrandTabFilterTopLiBlock = styled.li`
`;

const SearchBrandTabFilterTopButtonBlock = styled.button`
    ${isMobileOnly?`
    font-size: 18px;
    font-weight: 700;
    padding: 20px 0;
    `:`
    
    `};
`;

const SearchLangFindFilterBlock = styled.div`
    display: ${props => props.display};
    ${isMobileOnly?`
    padding: 20px 0px;
    `:`
    padding: 20px 30px;
    `};

    background-color: #f4f4f4;

    ::after {
        content: '';
        display: block;
        clear: both;
    }
`;

const SearchLangFindFilterUlBlock = styled.ul`
    float: left;
    ${isMobileOnly?"margin: 0.5rem 0":"margin-left: 52px"};
    &:nth-child(1) {
        margin-left: 0;
    }

    ::after {
        content: '';
        display: block;
        clear: both;
    }
`;

const SearchLangFindFilterLiBlock = styled.li`
    float: left;
    margin-left: 8px;
    pointer-events: ${props => props.disable};
`;

const SearchLangFindFilterBtn = styled.button`
    line-height: 1;
    color: ${props => props.colorF};
    font-size: 20px;
    font-weight: 500;
`;

const SearchLangFindFilterMBlock = styled.div`
    width: 100vw;
    //margin-left: -4vw;

    .mobile-brand-conatiner {
        overflow: scroll;
        overflow-y: hidden;
        display: flex;
        //padding: 0 0 10px 0;
        //width: max-content;
        .mobile-band {
            margin-left: 8px;
        }

        .mobile-band:last-child {
            padding-right: 4vw;
        }
        .mobile-band:first-child {
            margin-left: 4vw;
        }
    }

`;

const SearchFilterList = [
    { value: 'ㄱ', label: '가' }, { value: 'ㄴ', label: '나' }, { value: 'ㄷ', label: '다' }, { value: 'ㄹ', label: '라' },
    { value: 'ㅁ', label: '마' }, { value: 'ㅂ', label: '바' }, { value: 'ㅅ', label: '사' },
    { value: 'ㅇ', label: '아' }, { value: 'ㅈ', label: '자' }, { value: 'ㅊ', label: '차' }, { value: 'ㅋ', label: '카' },
    { value: 'ㅌ', label: '타' }, { value: 'ㅍ', label: '파' }, { value: 'ㅎ', label: '하' },
    { value: 'A' }, { value: 'B' }, { value: 'C' }, { value: 'D' }, { value: 'E' }, { value: 'F' }, { value: 'G' },
    { value: 'H' }, { value: 'I' }, { value: 'J' }, { value: 'K' }, { value: 'L' }, { value: 'M' }, { value: 'N' },
    { value: 'O' }, { value: 'P' }, { value: 'Q' }, { value: 'R' }, { value: 'S' }, { value: 'T' }, { value: 'U' },
    { value: 'V' }, { value: 'W' }, { value: 'X' }, { value: 'Y' }, { value: 'Z' },
    { value: '0-9' },
];

const RETRY_COUNT = 3;

const BRAND_ITEM_OFFSET = 20;

const SearchLangFindFilter = ({ showBlock }) => {
    const dispatch = useDispatch();
    const [reTryStat, setReTryStat] = useState(0);
    const [reTryProduct, setReTryProduct] = useState(0);
    const [changeState, setChangeState] = useState(false);

    const { statInfo, errorStat, searchText, loading, filterIndex, errorBrandProduct, errorBrandProductDefault, saveText } = useSelector(
        ({ searchReducer, loadingReducer }) => ({
            statInfo: searchReducer.statInfo,
            errorStat: searchReducer.errorStat,
            searchText: searchReducer.searchText,
            loading: loadingReducer['search/GET_STAT'],
            filterIndex: searchReducer.filterIndex,
            errorBrandProduct: searchReducer.errorBrandProduct,
            errorBrandProductDefault: searchReducer.errorBrandProductDefault,
            saveText: searchReducer.saveText,
        })
    );

    //필터 선택
    const handleClick = (index) => {
        // console.log('handleClick = ' + index);
        dispatch(reSetBrandProductErrorAction());
        //all 호출
        if (index === filterIndex) {
            let brandId = getBrandIdFromStatFilter("0", 3);
            dispatch(getBrandProductInfoAction(searchText, brandId, "all", "3", "0"));
            dispatch(setSearchFilterDataAction({ data: "all", type: "3", offset: "0" }));
            dispatch(setSearchFilerIndexAction(-1));
            return;
        }
        if (index < 14) {
            let brandId = getBrandIdFromStatFilter(SearchFilterList[index].value, 0);
            dispatch(getBrandProductInfoAction(searchText, brandId, SearchFilterList[index].value, "0", "0"));
            dispatch(setSearchFilterDataAction({ data: SearchFilterList[index].value, type: "0", offset: "0" }));
        }
        else if (index > 13 && index < 40) {
            let brandId = getBrandIdFromStatFilter(SearchFilterList[index].value, 1);
            dispatch(getBrandProductInfoAction(searchText, brandId, SearchFilterList[index].value, "1", "0"));
            dispatch(setSearchFilterDataAction({ data: SearchFilterList[index].value, type: "1", offset: "0" }));
        }
        else {
            //dispatch(getBrandProductInfoAction("0","1","0"));
            dispatch(setSearchFilterDataAction({ data: "0", type: "1", offset: "0" }));
        }
        //setCurFilterIndex(index)
        dispatch(setSearchFilerIndexAction(index));

    }

    const reTryBrandProduct = (index) => {
        // console.log('reTryBrandProduct = ' + index);
        //dispatch(reSetBrandProductErrorAction());
        //all 호출
        if (index === -1) {
            let brandId = getBrandIdFromStatFilter("0", 3);
            dispatch(getBrandProductInfoAction(searchText, brandId, "all", "3", "0"));
            return;
        }
        if (index < 14) {
            let brandId = getBrandIdFromStatFilter(SearchFilterList[index].value, 0);
            dispatch(getBrandProductInfoAction(searchText, brandId, SearchFilterList[index].value, "0", "0"));
        }
        else if (index > 13 && index < 40) {
            let brandId = getBrandIdFromStatFilter(SearchFilterList[index].value, 1);
            dispatch(getBrandProductInfoAction(searchText, brandId, SearchFilterList[index].value, "1", "0"));
        }
        else {
        }

    }

    // 검색어가 있으면 필터 정보 요청, 검색어가 없으면 디폴트 브랜드 상품 정보 요청
    useEffect(() => {
        if (searchText !== null && searchText.length > 0 && searchText !== saveText) {
            // console.log("getStatAction1111");
            dispatch(getStatAction(searchText));
            dispatch(setSearchFilerIndexAction(-1));
            dispatch(setSearchFilterDataAction({ data: "all", type: "3", offset: "0" }));
            dispatch(setSaveTextAction(searchText))
            setChangeState(true);
        }
        else if (searchText === null || (searchText !== null && searchText.length === 0)) {
            dispatch(getBrandProductDefaultAction());
        }
    }, [searchText])

    //필터 정보 요청 에러 발생시, 3번 재요청
    useEffect(() => {
        if (errorStat !== null && reTryStat < RETRY_COUNT) {
            if (searchText !== null && searchText.length > 0) {
                // console.log("getStatAction222");
                dispatch(getStatAction(searchText));
                dispatch(setSearchFilerIndexAction(-1));
                setReTryStat(reTryStat + 1);
                //dispatch(reSetStatErrorAction());
            }
        }
        else {
            setReTryStat(0);
        }
    }, [errorStat])

    //브랜드 상품 정보 요청 에러나면 3번 재요청
    useEffect(() => {
        //console.log("errorBrandProduct = " + JSON.stringify(errorBrandProduct));
        // console.log("reTryProduct = " + reTryProduct);
        if (errorBrandProduct !== null && reTryProduct < RETRY_COUNT) {
            if (searchText !== null && searchText.length > 0 && statInfo && statInfo.totalnum > 0) {
                // console.log('useEffect filterIndex = ' + filterIndex);
                reTryBrandProduct(filterIndex);
            }
            let count = reTryProduct + 1;
            // console.log("reTryProduct = " + count);
            setReTryProduct(count);
            //dispatch(reSetBrandProductErrorAction());
        }
        else if (errorBrandProduct === null) {
            setReTryProduct(0);
            // console.log("reTryProduct =  00000000  " );
        }
    }, [errorBrandProduct])

    //디폴트 브랜드/상품 정보 요청 에러나면 3번 재요청
    useEffect(() => {
        if (errorBrandProductDefault !== null && reTryProduct < RETRY_COUNT) {
            dispatch(getBrandProductDefaultAction());
            setReTryProduct(reTryProduct + 1);
            //dispatch(reSetBrandProductDefaultErrorAction());
        }
        else if (errorBrandProductDefault === null) {
            setReTryProduct(0);
        }
    }, [errorBrandProductDefault])

    // 검색어 요청 완료 후, 필터 정보가 있으면 전체 브랜드/상품 데이터 요청
    // 검색어 요청 완료 후, 필터 정보가 없으면 디폴트 브랜드/상품 데이터 요청
    useEffect(() => {
        if (statInfo !== null && statInfo.totalnum > 0 && filterIndex === -1) {
            if (searchText !== null && searchText.length > 0 && changeState === true) {
                let brandId = getBrandIdFromStatFilter("0", 3);
                dispatch(getBrandProductInfoAction(searchText, brandId, "all", "0", "0"));
                dispatch(setSearchFilterDataAction({ data: "all", type: "3", offset: "0" }));
                setChangeState(false);
            }
        }

        if (statInfo !== null && statInfo.totalnum === 0) {
            dispatch(getBrandProductDefaultAction());
        }
    }, [statInfo])

    const getTitle = () => {
        if (searchText === null || (searchText != null && searchText.length === 0)) {
            return "이런 상품은 어떠세요?";
        }
        else {
            if (statInfo !== null && statInfo.totalnum === 0) {
                return "이런 상품은 어떠세요?";
            }
            else if (statInfo !== null && statInfo.totalnum >= 0) {
                let stringTitle = "상품 ( " + statInfo.totalnum + " )";
                return stringTitle;
            }
        }
    }

    if (statInfo === null || searchText === null || searchText.length < 1 || statInfo.totalnum < 1) {
        return (
            isMobileOnly?
            <SearchBrandTabBlock className="brand-tab margin_b-30">
                <SearchBrandTabFilterTopBlock className="filter-top clearfix">
                <SearchBrandTabFilterTopUlBlock className="f-left clearfix">
                    <SearchBrandTabFilterTopLiBlock className="active">
                        <SearchBrandTabFilterTopButtonBlock>
                            {getTitle()}
                        </SearchBrandTabFilterTopButtonBlock>
                    </SearchBrandTabFilterTopLiBlock>
                </SearchBrandTabFilterTopUlBlock>
            </SearchBrandTabFilterTopBlock>
            </SearchBrandTabBlock>
            :
            <SearchBrandTabBlock className="brand-tab margin_b-30">
                <SearchBrandTabFilterTopBlock className="filter-top clearfix">
                    <SearchBrandTabFilterTopUlBlock className="tab-list f-left clearfix">
                        <SearchBrandTabFilterTopLiBlock className="active">
                            <SearchBrandTabFilterTopButtonBlock>
                                {getTitle()}
                            </SearchBrandTabFilterTopButtonBlock>
                        </SearchBrandTabFilterTopLiBlock>
                    </SearchBrandTabFilterTopUlBlock>
                </SearchBrandTabFilterTopBlock>
            </SearchBrandTabBlock>
        );
    }

    const getBrandIdFromStatFilter = (value, type) => {
        //type : 0 한글  1: 영어  3: 전체
        if (type === 0) {
            let index = statInfo.filterBrandInfo.han.findIndex(x => x.key === value);
            let bucket = statInfo.filterBrandInfo.han[index].BrandId.buckets;
            let stringId = bucket[0].key;
            for (var i = 1; i < bucket.length && i < BRAND_ITEM_OFFSET; i++) {
                stringId = stringId + "," + bucket[i].key;
            }

            return stringId;
        }
        else if (type === 1) {
            let index = statInfo.filterBrandInfo.eng.findIndex(x => x.key === value);
            let bucket = statInfo.filterBrandInfo.eng[index].BrandId.buckets;
            let stringId = bucket[0].key;
            for (var i = 1; i < bucket.length && i < BRAND_ITEM_OFFSET; i++) {
                stringId = stringId + "," + bucket[i].key;
            }

            return stringId;
        }
        else if (type === 3) {
            let bucket = statInfo.dataList;
            let stringId = bucket[0].key;
            for (var i = 1; i < bucket.length && i < BRAND_ITEM_OFFSET; i++) {
                stringId = stringId + "," + bucket[i].key;
            }
            return stringId;
        }
    }

    const isNumberEnable = () => {
        let retValue = false;
        statInfo.filterBrandInfo.eng.map((item) => {
            if (isNaN(item.key) === false) {
                // console.log("isNumberEnable = " +item.key)
                retValue = true;
            }

            return retValue;
        });

        return retValue;
    }

    const isSafari = () => {
        var ua = navigator.userAgent.toLocaleLowerCase();
        /* MSIE used to detect old browsers and Trident used to newer ones*/
        //console.log("ua = " + ua);
        var is_safari = ua.indexOf("safari") > -1 && ua.indexOf("chrom") === -1;
        //console.log("is_safari = " + is_safari);
        return is_safari;
    }

    return (
        isMobileOnly?
        <SearchBrandTabBlock className="brand-tab margin_b-30">
            <SearchBrandTabFilterTopBlock className="filter-top clearfix">
                <SearchBrandTabFilterTopUlBlock className="f-left clearfix">
                    <SearchBrandTabFilterTopLiBlock className="active">
                        <SearchBrandTabFilterTopButtonBlock>
                            {getTitle()}
                        </SearchBrandTabFilterTopButtonBlock>
                    </SearchBrandTabFilterTopLiBlock>
                </SearchBrandTabFilterTopUlBlock>
            </SearchBrandTabFilterTopBlock>

            <SearchLangFindFilterBlock display={showBlock}>
                <SearchLangFindFilterMBlock>
                    <div className="mobile-brand-conatiner">
                        {
                            SearchFilterList.map((item, index) => {
                                if (index < 14 && statInfo.filterBrandInfo.han.find(x => x.key === item.value)) {
                                    return (
                                        <div className="mobile-band" key={item.value} onClick={() => handleClick(index)}
                                            disable={statInfo.filterBrandInfo.han.find(x => x.key === item.value) ? '' : 'none'} >
                                            <SearchLangFindFilterBtn colorF={index === filterIndex ? '#111' : '#999'}>
                                                {item.label}
                                            </SearchLangFindFilterBtn>
                                        </div>)
                                }
                                return (null);
                            })
                        }
                        {
                            //영어
                            SearchFilterList.map((item, index) => {
                                if (index > 13 && index < 40 && statInfo.filterBrandInfo.eng.find(x => x.key === item.value) ) {
                                    return (
                                        <div className="mobile-band"  key={item.value} onClick={() => handleClick(index)}
                                            disable={statInfo.filterBrandInfo.eng.find(x => x.key === item.value) ? '' : 'none'} >
                                            <SearchLangFindFilterBtn colorF={index === filterIndex ? '#111' : '#999'}>
                                                {item.value}
                                            </SearchLangFindFilterBtn>
                                        </div>)
                                }
                                return (null);
                            })
                        }
                        {
                            //숫자
                            SearchFilterList.map((item, index) => {
                                if (index > 39 && isNumberEnable()) {
                                    return (
                                        <div className="mobile-band" /* style={isSafari() ? { marginLeft: "3px" } : { marginLeft: "8px" }} */ key={item.value} onClick={() => handleClick(index)}
                                            disable={isNumberEnable() ? '' : 'none'} >
                                            <SearchLangFindFilterBtn colorF={index === filterIndex ? '#111' : '#999'}>
                                                {item.value}
                                            </SearchLangFindFilterBtn>
                                        </div>)
                                }
                                return (null);
                            })
                        }
                    </div>
                </SearchLangFindFilterMBlock>
            </SearchLangFindFilterBlock>
        </SearchBrandTabBlock>
        :
        <SearchBrandTabBlock className="brand-tab margin_b-30">
            <SearchBrandTabFilterTopBlock className="filter-top clearfix">
                <SearchBrandTabFilterTopUlBlock className="tab-list f-left clearfix">
                    <SearchBrandTabFilterTopLiBlock className="active">
                        <SearchBrandTabFilterTopButtonBlock>
                            {getTitle()}
                        </SearchBrandTabFilterTopButtonBlock>
                    </SearchBrandTabFilterTopLiBlock>
                </SearchBrandTabFilterTopUlBlock>
            </SearchBrandTabFilterTopBlock>

            <SearchLangFindFilterBlock display={showBlock}>
                <SearchLangFindFilterUlBlock>
                    {
                        //한글
                        SearchFilterList.map((item, index) => {
                            if (index < 14) {
                                return (
                                    <SearchLangFindFilterLiBlock style={isSafari() ? { marginLeft: "3px" } : { marginLeft: "8px" }} key={item.value} onClick={() => handleClick(index)}
                                        disable={statInfo.filterBrandInfo.han.find(x => x.key === item.value) ? '' : 'none'} >
                                        <SearchLangFindFilterBtn colorF={index === filterIndex ? '#111' : '#999'}>
                                            {item.label}
                                        </SearchLangFindFilterBtn>
                                    </SearchLangFindFilterLiBlock>)
                            }
                            return (null);
                        })
                    }
                </SearchLangFindFilterUlBlock>
                <SearchLangFindFilterUlBlock>
                    {
                        //영어
                        SearchFilterList.map((item, index) => {
                            if (index > 13 && index < 40) {
                                return (
                                    <SearchLangFindFilterLiBlock style={isSafari() ? { marginLeft: "3px" } : { marginLeft: "8px" }} key={item.value} onClick={() => handleClick(index)}
                                        disable={statInfo.filterBrandInfo.eng.find(x => x.key === item.value) ? '' : 'none'} >
                                        <SearchLangFindFilterBtn colorF={index === filterIndex ? '#111' : '#999'}>
                                            {item.value}
                                        </SearchLangFindFilterBtn>
                                    </SearchLangFindFilterLiBlock>)
                            }
                            return (null);
                        })
                    }
                </SearchLangFindFilterUlBlock>
                <SearchLangFindFilterUlBlock>
                    {
                        //숫자
                        SearchFilterList.map((item, index) => {
                            if (index > 39) {
                                return (
                                    <SearchLangFindFilterLiBlock style={isSafari() ? { marginLeft: "3px" } : { marginLeft: "8px" }} key={item.value} onClick={() => handleClick(index)}
                                        disable={isNumberEnable() ? '' : 'none'} >
                                        <SearchLangFindFilterBtn colorF={index === filterIndex ? '#111' : '#999'}>
                                            {item.value}
                                        </SearchLangFindFilterBtn>
                                    </SearchLangFindFilterLiBlock>)
                            }
                            return (null);
                        })
                    }
                </SearchLangFindFilterUlBlock>
            </SearchLangFindFilterBlock>
        </SearchBrandTabBlock>
    );

};

export default SearchLangFindFilter;
